import Vue from 'vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import Clipboard from 'clipboard';
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)

var func = {
setSession(key, value) {
return window.sessionStorage.setItem(key, value);
},
getSession(key) {
return window.sessionStorage.getItem(key);
},
setLocal(key, value) {
return window.localStorage.setItem(key, value);
},
getLocal(key) {
return window.localStorage.getItem(key);
},
showToast(msg){
Vue.$vux.loading.hide();
Vue.$vux.toast.text(msg ? msg : '服务器跑丢了', 'middle')
},
startLoading(title){
Vue.$vux.loading.show({
text: title ? title : '加载中。。。'
})
},
endLoading(){
Vue.$vux.loading.hide()
},
alert(content,title){
Vue.$vux.alert.show({
title: title ? title : '温馨提示',
content: content,
onShow () {
console.log('Plugin: I\'m showing')
},
onHide () {
console.log('Plugin: I\'m hiding')
}
})
},
confirm(content,title,callfun){
Vue.$vux.confirm.show({
title:title ? title : '温馨提示',
content:content,
onCancel () {
console.log('Plugin: I\'m onCancel')
},
onConfirm () {
callfun ? callfun() : '';
console.log('Plugin: I\'m onConfirm')
}
})
},
copy(text, event, onSuccess, onError) {
event = event || {};
const clipboard = new Clipboard(event.target, {
text: () => text,
});
clipboard.on('success', () => {
onSuccess ? onSuccess() : Vue.$vux.toast.text('已复制');
clipboard.off('error');
clipboard.off('success');
clipboard.destroy();
});
clipboard.on('error', () => {
onError ? onError() : Vue.$vux.toast.text('复制失败');
clipboard.off('error');
clipboard.off('success');
clipboard.destroy();
});
clipboard.onClick(event);
},
checkAuth(val){

if(this.getLocal('node_v1')){
let node = JSON.parse(this.getLocal('node_v1'));

return node[val] ? true : false;
}
}
}
export default func;



// WEBPACK FOOTER //
// ./src/utils/func.js